import { Badge } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { Schedule_Template } from "../../../js/parsegenerated";

type Props = {
  schedule: Schedule_Template;
};

export default observer((props: Props) => {
  return (
    <Badge
      color={props.schedule.get("color") ?? "black"}
      text={props.schedule.get("title")}
    />
  );
});
